export default {
    mounted(el, binding) {
        el.classList.add('subscription-feature');

        // Zugriff auf den Komponenten-Kontext (Vue 3 Syntax)
        const instance = binding.instance;

        if (!instance?.$userData?.rights?.accessSubscriptionFeatures && !instance?.$userData?.rights?.accessAlphaFeatures) {
            el.style.opacity = '0.35';
            el.style.pointerEvents = 'none';
            el.disabled = true;
        }
    }
}